import ServicesPanel from '.';
import Icon from '../icon';

export interface ServiceData {
	id: number;
	url: string;
	name: string;
	title: string;
	excerpt: string;
	services: string;
	image: string;
	icon: string;
}

export class Service {
	private _isActive: boolean = false;
	private readonly excerpt: string[];
	private readonly services: string[];
	private readonly navItem: HTMLLIElement = document.createElement('li');
	private readonly details: HTMLDivElement = document.createElement('div');
	private readonly content: HTMLDivElement = document.createElement('div');
	private readonly servicesList: HTMLUListElement = document.createElement('ul');
	private readonly button: HTMLAnchorElement = document.createElement('a');
	private readonly image: HTMLDivElement = document.createElement('div');

	constructor(private readonly panel: ServicesPanel, private readonly data: ServiceData) {
		this.excerpt = this.split(this.data.excerpt);
		this.services = this.split(this.data.services);
		this.navItem.innerText = this.data.title;
		this.button.href = this.data.url;
		this.button.append(_t('learnMore') + ' ', Icon.create('long-arrow-right'));
		this.button.classList.add('btn');

		this.panel.navList.append(this.navItem);
		this.panel.details.append(this.details);
		this.details.append(this.content, this.image);

		this.content.append(...this.excerpt.map((innerText) => Object.assign(document.createElement('p'), {innerText})));
		if (this.services.length) this.content.append(Object.assign(document.createElement('h4'), {innerText: _t('services')}), this.servicesList);
		this.servicesList.append(...this.services.map((innerText) => Object.assign(document.createElement('li'), {innerText})));
		this.content.append(this.button);

		this.navItem.addEventListener('click', () => this.panel.activateService(this));
	}

	private split(input: string): string[] {
		return input
			.split('\n')
			.map((line) => line.trim())
			.filter((line) => line);
	}

	public async loadImage(): Promise<void> {
		if (!this.data.image) return;
		this.image.style.backgroundImage = `url('${this.data.image}')`;
		await new Promise<void>((resolve) => {
			const image = new Image();
			image.addEventListener('load', () => resolve());
			image.addEventListener('error', () => resolve());
			image.src = this.data.image;
		});
	}

	public set isActive(isActive: boolean) {
		this._isActive = isActive;
		this.navItem.classList.toggle('active', this._isActive);
		this.details.classList.toggle('active', this._isActive);
	}

	public get isActive(): boolean {
		return this._isActive;
	}
}
